 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"videocall":"videocall","agoraclient":"agoraclient","ringer":"ringer","twilio-client":"twilio-client","controls":"controls"}[chunkId]||chunkId) + "." + {"chunk-009661df":"e98ec854","chunk-07118b82":"088678a2","chunk-3da0b5e9":"e0d89d22","chunk-44752ccc":"ed5f2b95","chunk-8189b204":"1ccd9af5","chunk-590715ae":"0a72e86b","chunk-63518c8c":"aaf7fe2a","chunk-2d0ccf5c":"bf077255","chunk-9faabf0a":"1eea6567","chunk-679a2ce1":"f725e970","chunk-26e47d30":"72ac7b53","chunk-6e397eec":"4927d1fe","chunk-9fd1906a":"930281e7","chunk-a0c1c0f6":"868f25be","chunk-37451f1a":"62309b2b","chunk-45f20786":"382ffbf9","chunk-ab981264":"e9abeace","chunk-13b8b38a":"65479c91","chunk-1a418c5c":"061c5914","chunk-57ba297e":"351b6cba","chunk-47307289":"2aa37c28","chunk-2d22d7ba":"ec6277b5","chunk-e3154134":"d024c30a","chunk-e679a95e":"b7c497ed","chunk-eced58e4":"334dc031","chunk-0cdd8aa5":"47ece522","chunk-a5e277f8":"e58d54c6","chunk-2d0a4c17":"44698600","chunk-2d0ac448":"1f932c3b","chunk-2d20f5c3":"a617a07f","chunk-2d21ecdb":"e3b8e426","chunk-4d96801b":"5efbf7b8","chunk-5dcf1116":"340240d5","chunk-65c6ca5a":"4f7211c8","chunk-6724aa68":"9f4e56ff","chunk-3eaa0c93":"82cd0f0d","chunk-6899e037":"77a1d582","chunk-96438a5e":"7ff82db8","chunk-9e69a5c8":"73716950","chunk-1af67e72":"cb805d5f","chunk-7871b56a":"5ba8b807","chunk-f49161ba":"7920809d","videocall":"067d95a8","agoraclient":"da5a95fb","ringer":"e98e2fdd","twilio-client":"df08b3af","controls":"437e4e32"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-26e47d30":1,"chunk-37451f1a":1,"chunk-45f20786":1,"chunk-47307289":1,"chunk-eced58e4":1,"chunk-4d96801b":1,"chunk-5dcf1116":1,"chunk-3eaa0c93":1,"chunk-6899e037":1,"chunk-7871b56a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"videocall":"videocall","agoraclient":"agoraclient","ringer":"ringer","twilio-client":"twilio-client","controls":"controls"}[chunkId]||chunkId) + "." + {"chunk-009661df":"31d6cfe0","chunk-07118b82":"31d6cfe0","chunk-3da0b5e9":"31d6cfe0","chunk-44752ccc":"31d6cfe0","chunk-8189b204":"31d6cfe0","chunk-590715ae":"31d6cfe0","chunk-63518c8c":"31d6cfe0","chunk-2d0ccf5c":"31d6cfe0","chunk-9faabf0a":"31d6cfe0","chunk-679a2ce1":"31d6cfe0","chunk-26e47d30":"15faea24","chunk-6e397eec":"31d6cfe0","chunk-9fd1906a":"31d6cfe0","chunk-a0c1c0f6":"31d6cfe0","chunk-37451f1a":"d3af1aa6","chunk-45f20786":"7fbab0c8","chunk-ab981264":"31d6cfe0","chunk-13b8b38a":"31d6cfe0","chunk-1a418c5c":"31d6cfe0","chunk-57ba297e":"31d6cfe0","chunk-47307289":"d91efe40","chunk-2d22d7ba":"31d6cfe0","chunk-e3154134":"31d6cfe0","chunk-e679a95e":"31d6cfe0","chunk-eced58e4":"d91efe40","chunk-0cdd8aa5":"31d6cfe0","chunk-a5e277f8":"31d6cfe0","chunk-2d0a4c17":"31d6cfe0","chunk-2d0ac448":"31d6cfe0","chunk-2d20f5c3":"31d6cfe0","chunk-2d21ecdb":"31d6cfe0","chunk-4d96801b":"44f9f53f","chunk-5dcf1116":"f9cc9e35","chunk-65c6ca5a":"31d6cfe0","chunk-6724aa68":"31d6cfe0","chunk-3eaa0c93":"0aa325aa","chunk-6899e037":"d674543e","chunk-96438a5e":"31d6cfe0","chunk-9e69a5c8":"31d6cfe0","chunk-1af67e72":"31d6cfe0","chunk-7871b56a":"1710dd97","chunk-f49161ba":"31d6cfe0","videocall":"31d6cfe0","agoraclient":"31d6cfe0","ringer":"31d6cfe0","twilio-client":"31d6cfe0","controls":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
